import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { financialEffectsLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/financial-effects/selection-state';
import { financialEffectsLensTexts } from '@upright/ui/common/upright/core/impact-lenses/financial-effects/texts';
import {
  FinancialEffectsLensData,
  FinancialEffectsLensOptions,
} from '@upright/ui/common/upright/core/impact-lenses/financial-effects/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';

export const financialEffectsLens: ImpactLens<
  ImpactLensType.FINANCIAL_EFFECTS,
  FinancialEffectsLensData,
  FinancialEffectsLensOptions
> = {
  type: ImpactLensType.FINANCIAL_EFFECTS,
  ImpactDataComponent: { component: () => <></> },
  infoBoxes: {},
  ...financialEffectsLensSelectionState,
  ...financialEffectsLensTexts,
};
